import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isEmpty, isArray } from 'lodash';

import AddRepresentativeButton from './AddRepresentativeButton';
import RepresentativeSummary from './RepresentativeSummary';
import AddRepresentativeModal from './AddRepresentativeModal';

const AddRepresentative = ({
  isEditable,
  application,
  party,
  representative,
  isPartyTypeCompany,
  documents,
  docsAttributes,
  mandatory,
  alertText,
  addForAllPartiesText,
  disableAddBtn,
  error,
  addRepresentativeHandler,
  deleteRepresentativeHandler,
}) => {
  if (isEditable === false && isEmpty(representative)) return null;

  const [openModal, setOpenModal] = useState(false);
  const locale = useSelector(state => state.language.locale);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleAddRepresentative = data => {
    handleCloseModal(false);
    addRepresentativeHandler(data);
  };

  return (
    <>
      {isEditable === true && (
        <AddRepresentativeButton
          addRepresentativeHandler={handleOpenModal}
          mandatory={mandatory}
          disableAddBtn={disableAddBtn}
          alertText={alertText}
        />
      )}
      {!isEmpty(representative) && (
        <RepresentativeSummary
          locale={locale}
          isEditable={isEditable}
          application={application}
          representative={representative}
          party={party}
          documents={isArray(documents) ? documents : []}
          docsAttributes={docsAttributes}
          editRepresentativeHandler={handleOpenModal}
          deleteRepresentativeHandler={deleteRepresentativeHandler}
        />
      )}
      {isEditable === true && openModal === true && (
        <AddRepresentativeModal
          openModal={openModal}
          application={application}
          party={party}
          representative={representative}
          isPartyTypeCompany={isPartyTypeCompany}
          addForAllPartiesText={addForAllPartiesText}
          documents={isArray(documents) ? documents : []}
          docsAttributes={docsAttributes}
          error={error}
          closeModalHandler={handleCloseModal}
          addRepresentativeHandler={handleAddRepresentative}
        />
      )}
    </>
  );
};

AddRepresentative.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  application: PropTypes.object.isRequired,
  party: PropTypes.object.isRequired,
  representative: PropTypes.object.isRequired,
  isPartyTypeCompany: PropTypes.bool,
  mandatory: PropTypes.bool,
  alertText: PropTypes.string,
  disableAddBtn: PropTypes.bool,
  addForAllPartiesText: PropTypes.string,
  documents: PropTypes.array.isRequired,
  docsAttributes: PropTypes.array.isRequired,
  error: PropTypes.any.isRequired,
  addRepresentativeHandler: PropTypes.func.isRequired,
  deleteRepresentativeHandler: PropTypes.func.isRequired,
};

AddRepresentative.defaultProps = {
  isPartyTypeCompany: false,
  addForAllPartiesText: '',
  mandatory: false,
  alertText: '',
  disableAddBtn: false,
};

export default AddRepresentative;
